import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { MachineTypeComponent } from './machineType.component';
import { MachineTypeListComponent } from './machineType-list.component';
import { MachineTypeReadComponent } from './machineType-read.component';
import { MachineTypeCreateComponent } from './machineType-create.component';
import { MachineTypeUpdateComponent } from './machineType-update.component';
import { MachineTypeService } from './machineType.service';
import { dashboardRouting } from '../dashboard/dashboard.routes';
import { ContextMenuModule } from 'ngx-contextmenu';
import { MatTableModule, MatCheckboxModule, MatPaginatorModule, MatSortModule, MatSelectModule, MatExpansionModule } from '@angular/material';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		dashboardRouting,
		FormsModule,
		ReactiveFormsModule,
		ContextMenuModule,
		MatTableModule,
		MatCheckboxModule,
		MatPaginatorModule,
		MatSortModule,
		MatExpansionModule,
		MatSelectModule
	],
	declarations: [
		MachineTypeComponent,
		MachineTypeListComponent,
		MachineTypeReadComponent,
		MachineTypeCreateComponent,
		MachineTypeUpdateComponent
	],
	providers: [
		MachineTypeService
	],
})
export class MachineTypeModule { }
